export default "__VITE_ASSET__DwJpgbIY__"